import type { TopMenuItem } from './api/legacy-api';

export interface NavigationItem {
  href: `/portal/${string}`;
  title: string;
}

export function toShellHref(
  destination: string,
  portalUrl: string
): NavigationItem['href'] | undefined {
  try {
    const base = new URL(portalUrl);
    const url = new URL(destination, base);
    if (url.origin !== base.origin || !['http:', 'https:'].includes(url.protocol)) {
      return undefined;
    }
    return `/portal/${url.pathname.slice(1)}${url.search}${url.hash}`;
  } catch {
    return undefined;
  }
}

export function toNavigationItems(items: TopMenuItem[], portalUrl: string): NavigationItem[] {
  return items.flatMap((item) => {
    const href = toShellHref(item.url, portalUrl);
    return href ? [{ href, title: item.title }] : [];
  });
}

export function resolveLegacyDestination(shellUrl: URL, portalUrl: string): string | undefined {
  if (shellUrl.pathname !== '/portal' && !shellUrl.pathname.startsWith('/portal/')) {
    return undefined;
  }

  const url = new URL(portalUrl);
  // Assign the path rather than resolving it: a legacy //path must stay on this origin.
  url.pathname = shellUrl.pathname.slice('/portal'.length) || '/';
  url.search = shellUrl.search;
  url.hash = shellUrl.hash;
  return url.toString();
}

export function isNavigationItemActive(href: string, currentUrl: URL): boolean {
  const destination = new URL(href, currentUrl.origin);
  const path = destination.pathname.replace(/\/$/, '');
  const currentPath = currentUrl.pathname.replace(/\/$/, '');
  return (
    (currentPath === path || (path !== '/portal' && currentPath.startsWith(`${path}/`))) &&
    (!destination.search || destination.search === currentUrl.search)
  );
}
